import React, { useEffect, useState } from "react";
import { getPage } from 'services/api/Shop';
import { getOfflineContent, saveOfflineContent } from '../../utils/offlineContent';

const Faq = () => {
  const [data, setData] = useState("");
  const [isOfflineFallback, setIsOfflineFallback] = useState(false);

  useEffect(() => {
    const loadFaq = async () => {
      try {
        const token = sessionStorage.getItem('token') || "";
        const response = await getPage(142, token);
        const nextContent = response?.content?.content || "";

        if (!nextContent) {
          throw new Error('FAQ content unavailable');
        }

        setData(nextContent);
        setIsOfflineFallback(false);
        saveOfflineContent('faq-page', nextContent);
      } catch (_error) {
        const cachedContent = getOfflineContent('faq-page');

        if (cachedContent?.value) {
          setData(cachedContent.value);
          setIsOfflineFallback(true);
        }
      }
    };

    loadFaq();
  }, []);

  return (
    <div className="container">
      {isOfflineFallback && (
        <p className="offline-content-notice">
          Vous consultez la dernière version enregistrée de cette page.
        </p>
      )}
      {data ? (
        <div dangerouslySetInnerHTML={{__html: data}} />
      ) : (
        <p className="offline-content-notice">
          Le contenu de la FAQ est momentanément indisponible.
        </p>
      )}
    </div>
  )
}

export default Faq;
